import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export function exportSingleNCEToExcel(nce) {
  if (!nce) {
    console.error("Nenhum dado da NCE para exportar.");
    return;
  }

  // Começa com os campos principais
  const row = {
    "Número NCE": nce.ID_NCE,
    "Data Abertura": nce.dadosProduto?.DATA_ABERTURA,
    "Criado por": nce.dadosProduto?.RESPONSAVEL,
    "Unidade Solicitante": nce.dadosProduto?.GP_UNIDADE,
    "Unidade Fornecedor": nce.dadosProduto?.FOR_UNIDADE,
    "Fornecedor": nce.dadosProduto?.FORNECEDOR,
    "Produto": nce.dadosProduto?.DESCRICAO_PRODUTO,
    "Embalagem": nce.dadosProduto?.EMBALAGEM,
    "Número do Lote": nce.dadosProduto?.NUMERO_DO_LOTE,
    "Quantidade do Lote": nce.dadosProduto?.QUANTIDADE_DO_LOTE,
    "Quantidade Defeito": nce.dadosProduto?.QUANTIDADE_DE_DEFEITOS,
    "Quantidade Segregada": nce.dadosProduto?.QUANTIDADE_SEGREGADA,
    "Parada": nce.dadosProduto?.PARADA,
    "Origem NCE": nce.dadosProduto?.ORIGEM_NC,
    "Severidade": nce.dadosProduto?.SEVERIDADE,
    "Data Devolução Prevista": nce.dadosProduto?.DATA_DEVOLUCAO_NCE,
    "Status Etapa": nce.WORKFLOW?.etapa_descricao,
    "Finalizado": nce.WORKFLOW?.finalizado ?? "NÃO",

    // descricaoNCE
    "Tipo Defeito": nce.descricaoNCE?.TIPO_DE_DEFEITO,
    "NQA": nce.descricaoNCE?.NQA,
    "Plano": nce.descricaoNCE?.PLANO,
    "Nível de Inspeção": nce.descricaoNCE?.NIVEL_DE_INSPECAO,
    "Descrição Defeito": nce.descricaoNCE?.DESCRICAO_DO_DEFEITO,

    // disposicaoProduto
    "Disposição Produto": nce.disposicaoProduto?.DISPOSICAO,
  };

  // Função helper para preencher arrays
  const addArrayToRow = (arr, prefix, fields, maxItems = 5) => {
    if (!arr) return;
    for (let i = 0; i < Math.min(arr.length, maxItems); i++) {
      const item = arr[i];

      // verifica se tem algum conteúdo não vazio
      const hasContent = fields.some(
        (field) => item && item[field] && String(item[field]).trim() !== ""
      );

      if (hasContent) {
        fields.forEach((field) => {
          row[`${prefix}_${i + 1}_${field}`] = item ? item[field] ?? "" : "";
        });
      }
    }
  };

  // Arrays
  addArrayToRow(nce.imagens, "Imagem", ["IMAGEM"], 5);
  addArrayToRow(nce.acoesImediatas, "AcaoImediata", ["ACAO_DE_CONTENCAO", "QUEM", "QUANDO", "STATUS"], 5);
  addArrayToRow(nce.brainstorming, "Brainstorming", ["IDEIA"], 5);
  addArrayToRow(nce.causaeefeito, "CausaEfeito", ["CAUSA_E_EFEITO", "M", "DEFEITO"], 5);
  addArrayToRow(nce.cincoPorques, "CincoPorques", ["CAUSA_PROVAVEL", "PORQUE_UM", "PORQUE_DOIS", "PORQUE_TRES", "PORQUE_QUATRO", "PORQUE_CINCO"], 5);
  addArrayToRow(nce.planoAcao, "PlanoAcao", ["CAUSA_DA_OCORRENCIA", "ACAO", "TIPO", "QUEM", "QUANDO", "STATUS"], 5);
  addArrayToRow(
    nce.verificacaoEficacia,
    "VerificacaoEficacia",
    ["ABRANGENTE", "EFICAZ", "NUMERO_DO_PLANO_DE_ACAO", "CONCLUIDO_POR", "AREA_EMIT", "DATA"],
    5
  );

  // Montar planilha
  const worksheet = XLSX.utils.json_to_sheet([row]);

  // Ajuste de largura automática
  const colWidths = Object.keys(row).map((key) => ({
    wch: Math.max(15, key.length),
  }));
  worksheet["!cols"] = colWidths;

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "NCE");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, `${nce.ID_NCE}.xlsx`);
}
